银行余额看板
<template>
  <div class="threeLevelMain">
    <div class="queryBox">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">日期：</span>
          <el-date-picker
            size="mini"
            v-model="queryForm.time"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            @change="searchFunc"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="btn_area_out">
        <el-button size="mini" @click="resetQuery">重置查询</el-button>
        <el-button size="mini" @click="exportHandle">导出看板</el-button>
      </div>
    </div>
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :orderNumConfig="{}"
      :totalCount="totalCount"
    >
    </tablePageComp>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
export default {
  data() {
    return {
      dataList: [],
      updateDataTag: false,
      totalCount: 0, // 数据总条数
      columnsList: [
        {
          label: "日期",
          prop: "time",
          width: 100,
        },
        {
          label: "杭州百博电子商务有限公司-工商银行（基本户）",
          prop: "bank_name_one_money",
          width: 150,
        },
        {
          label: "杭州百博电子商务有限公司-杭州银行",
          prop: "bank_name_two_money",
          width: 150,
        },
        {
          label: "杭州百博知识产权有限公司-杭州银行",
          prop: "bank_name_three_money",
          width: 150,
        },
        {
          label: "杭州布洛船区块链科技有限公司-杭州银行",
          prop: "bank_name_four_money",
          width: 150,
        },
        {
          label: "杭州百博网络服务有限公司-杭州银行",
          prop: "bank_name_five_money",
          width: 150,
        },

        {
          label: "农行银行-丁欢",
          prop: "bank_name_six_money",
          width: 150,
        },
        {
          label: "支付宝-丁欢",
          prop: "bank_name_seven_money",
          width: 150,
        },
        {
          label: "光大银行-余烈",
          prop: "bank_name_eight_money",
          width: 150,
        },
        {
          label: "杭州百博品牌科技有限公司-杭州银行",
          prop: "bank_name_nine_money",
          width: 150,
        },
        {
          label: "杭州百博大数据服务有限公司-杭州银行",
          prop: "bank_name_eleven_money",
          width: 150,
        },
        {
          label: "可用余额",
          prop: "account_balance",
          width: 150,
        },
        {
          label: "借款",
          prop: "borrow_money",
          width: 150,
        },
        {
          label: "总余额",
          prop: "total_money",
          width: 150,
        },
      ],

      queryForm: {
        time: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    exportHandle() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let paramObj = {};
      if (this.queryForm.time) {
        paramObj.time = this.queryForm.time.join(",");
      }

      api
        .exportAllAccountBal(paramObj)
        .then((res) => {
          // console.log(res)
          loading.close();
          utils.downloadFile(res);
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          this.$message.error("导出失败");
        });
    },
    resetQuery() {
      Object.keys(this.queryForm).forEach((key) => (this.queryForm[key] = ""));
      this.updateDataTag = !this.updateDataTag;
    },
    searchFunc() {
      utils.debounceFunc(
        function() {
          this.updateDataTag = !this.updateDataTag;
        }.bind(this)
      );
    },
    dataQueryFunc() {
      let paramObj = {};
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key]) {
          paramObj[key] = this.queryForm[key];
        }
      });

      return {
        apiName: "getBankBalanceList",
        paramObj: paramObj,
        success: function(response, callBack) {
          // console.log(response)
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });

            arr.push(obj);
          }
          this.dataList = arr;
          this.totalCount = response.data.data.totalCount;

          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style></style>
